/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_OuterwearInputs */

const en_val_outerwear = /** @type {(inputs: Val_OuterwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outerwear`)
};

const es_val_outerwear = /** @type {(inputs: Val_OuterwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ropa de abrigo`)
};

const fr_val_outerwear = /** @type {(inputs: Val_OuterwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vêtements d'extérieur`)
};

const de_val_outerwear = /** @type {(inputs: Val_OuterwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberbekleidung`)
};

const ja_val_outerwear = /** @type {(inputs: Val_OuterwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アウターウェア`)
};

const zh_val_outerwear = /** @type {(inputs: Val_OuterwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外套`)
};

const ar_val_outerwear = /** @type {(inputs: Val_OuterwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملابس خارجية`)
};

const id_val_outerwear = /** @type {(inputs: Val_OuterwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakaian Luar`)
};

const it_val_outerwear = /** @type {(inputs: Val_OuterwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capispalla`)
};

const ru_val_outerwear = /** @type {(inputs: Val_OuterwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Верхняя одежда`)
};

const pt_val_outerwear = /** @type {(inputs: Val_OuterwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agasalhos`)
};

const ko_val_outerwear = /** @type {(inputs: Val_OuterwearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아우터`)
};

/**
* | output |
* | --- |
* | "Outerwear" |
*
* @param {Val_OuterwearInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_outerwear = /** @type {((inputs?: Val_OuterwearInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_OuterwearInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_outerwear(inputs)
	if (locale === "es") return es_val_outerwear(inputs)
	if (locale === "fr") return fr_val_outerwear(inputs)
	if (locale === "de") return de_val_outerwear(inputs)
	if (locale === "ja") return ja_val_outerwear(inputs)
	if (locale === "zh") return zh_val_outerwear(inputs)
	if (locale === "ar") return ar_val_outerwear(inputs)
	if (locale === "id") return id_val_outerwear(inputs)
	if (locale === "it") return it_val_outerwear(inputs)
	if (locale === "ru") return ru_val_outerwear(inputs)
	if (locale === "pt") return pt_val_outerwear(inputs)
	return ko_val_outerwear(inputs)
});